// extracted by mini-css-extract-plugin
export default {"button":"solid-button_button__DxM46","smallButton":"solid-button_smallButton__2CCE3"};